import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../../core/client';
import type { DeviceCatalogEntry, DeviceCatalogResponse } from './device-catalog.types';

const BASE = '/users/v1/admin/device-catalog';
const KEY = ['device-catalog'] as const;

/** One round trip for the whole console — the catalog is small by nature. */
export function useDeviceCatalog() {
  return useQuery({
    queryKey: KEY,
    queryFn: () => api.get<DeviceCatalogResponse>(BASE),
  });
}

/** POST upsert (empty id = create) for a catalog entry. */
export function useUpsertDeviceCatalogEntry() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (entry: DeviceCatalogEntry) => api.post<DeviceCatalogEntry>(BASE, entry),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useDeleteDeviceCatalogEntry() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.delete<boolean>(`${BASE}/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}
